import { RootState, store } from 'src/store'

export const getSlice = <T>(selector: (_: RootState) => T) =>
  selector(store.getState())
